import React from 'react';
import {
  Typography, Box, Card, useWidth,
} from 'vindi-ds-components';
import { PrCheckCircle } from 'vindi-ds-icons/pr';

const DefaultFooter = ({ children }) => (
  <Typography color='textSecondary' variant='body2'>
    { children }
  </Typography>
);

const Wrapper = ({ children, mobile }) => {
  const style = {
    display: 'flex',
    justifyContent: 'space-between',
  };

  return (
    <>
      {mobile && (<Box flexDirection='column' {...style}>{children}</Box>)}
      {!mobile && (<Box flexDirection='row' {...style}>{children}</Box>)}
    </>
  );
};

const DefaultCardLinks = () => (
  <>
  </>
);

function ScaffoldCard({
  css,
  CardFooter = DefaultFooter,
  CardLinks = DefaultCardLinks,
  iconColor,
  step,
  title,
  subtitle,
  isCompleted,
}) {
  const mobile = ['xs', 'sm', 'md'].includes(useWidth());
  const showIcon = !mobile && !isCompleted;
  return (
    <Card
      padding='small'
      css={css}
      width={!mobile && isCompleted ? '249px' : '100%'}
    >
      <Wrapper mobile={mobile}>
        <Box display='flex' flexDirection='row' alignItems='center'>
          {showIcon && (
            <Box marginRight='16px'>
              <PrCheckCircle size='32px' color={iconColor} />
            </Box>
          )}
          <Box>
            <Box>
              <Typography variant='body1' style={{ color: '#4D4D4D' }} weight='bold'>
                { `${step}. ${title}` }
              </Typography>
            </Box>
            <CardFooter>
              { subtitle }
            </CardFooter>
          </Box>
        </Box>
        <CardLinks />
      </Wrapper>
    </Card>
  );
}

export default ScaffoldCard;
